/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Route } from 'react-router-dom';
import { CustomerOrderList } from './customer-order';
import { Dashboard } from './dashboard';
import { OrderList } from './order-schedule';
import CustomerOrderSettlementList from './order-settlement/CustomerOrderSettlementList';
import SupplierOrderSettlementList from './order-settlement/SupplierOrderSettlementList';
import OrderItemCreate from './order/OrderItemCreate';
import { CustomerCalendar } from './settlement-customer-calendar';
import { SupplierCalendar } from './settlement-supplier-calendar';

const customRoutes = [
  <Route exact path='/dashboard' component={Dashboard} />,
  <Route exact path='/schedules' component={OrderList} />,
  <Route exact path='/customer/schedules' component={CustomerOrderList} />,
  <Route exact path='/supplier/settlement' component={SupplierCalendar} />,
  <Route exact path='/customer/settlement' component={CustomerCalendar} />,
  <Route exact path='/order/:orderId/items' component={OrderItemCreate} />,
  <Route
    path='/order/settlement/customer'
    component={CustomerOrderSettlementList}
  />,
  <Route
    path='/order/settlement/supplier'
    component={SupplierOrderSettlementList}
  />,
];

export default customRoutes;
